import { render, staticRenderFns } from "./HttpFiles.vue?vue&type=template&id=c94f8e22&scoped=true&"
import script from "./HttpFiles.vue?vue&type=script&lang=js&"
export * from "./HttpFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f8e22",
  null
  
)

export default component.exports